import { getHashObj, setHash, stringIsValidDate } from "@/utils/utils";

export default {
	readUrl: ({ dispatch }) => {
		dispatch("refreshStateFromHash");

		const hash = window.location.hash.replace("#", "");

		// get hash values
		const hashObj = getHashObj(hash);

		// set hash in case it was changed here
		setHash(hashObj);
	},

	refreshStateFromHash: ({ commit, dispatch }) => {
		const hashStr = window.location.hash.replace("#", "");
		const hashObj = getHashObj(hashStr);
		console.log("refreshStateFromHash");

		if (hashObj["packCode"]) commit("setPackage", hashObj["packCode"]);
		const beginDate = hashObj["BeginDate"];
		const endDate = hashObj["EndDate"];
		if (
			beginDate &&
			endDate &&
			stringIsValidDate(hashObj["BeginDate"]) &&
			stringIsValidDate(hashObj["EndDate"])
		) {
			commit("setStartDate", hashObj["BeginDate"]);
			commit("setEndDate", hashObj["EndDate"]);
			dispatch("refreshDataStoredOnWindow");
		}
	},
};
